import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/project-progress-form.scss';

Component('tr-project-progress-form', {
  mixins: [eventListenerMixin],

  properties: {
    portfolioId: String,
    url: String,
  },

  ready() {
    this.projectField = this.querySelector('.project-field .search-input');
    this.projectField.focus();
    this.listenTo(this, 'tr-combo-select-field:change', (e) => {
      const value = e.detail;
      this.submitForm(value);
    });
    this.listenTo(this, 'tr-selector-field-list:closed', () => {
      const value = this.querySelector('tr-combo-select-field').getValue();
      if (!value) this.remove();
    });
  },

  submitForm(projectGuid) {
    const data = {
      portfolio_id: this.portfolioId,
      project_guid: projectGuid,
    };

    $.ajax({
      url: this.url,
      method: 'post',
      dataType: 'script',
      data,
      beforeSend: () => {
        this.classList.add('loading');
      },
      complete: () => {
        this.classList.remove('loading');
      },
    });
  },
});
